import { jsx as t, jsxs as c, Fragment as ce } from "react/jsx-runtime";
import { Tag as me, LiteSupplierTag as ge } from "@strata/react-tags";
import { Tooltip as X } from "@strata/react-tooltip";
import "./main.scss";
import { flexRender as Z, useReactTable as ne, getSortedRowModel as pe, getCoreRowModel as le } from "@tanstack/react-table";
import { useVirtualizer as fe } from "@tanstack/react-virtual";
import u from "classnames";
import { useMemo as w, useState as V, useEffect as B, useRef as _e, useCallback as J } from "react";
import { Loading as be } from "@strata/react-loading-animation";
import { IconNames as U } from "@blueprintjs/icons";
import { MessagingBlock as q } from "@strata/react-messaging-block";
import { useResizeDetector as he } from "react-resize-detector";
import S from "dayjs";
import { SimpleSelect as ue } from "@strata/react-selects";
import { Icon as Y } from "@strata/react-status-icons";
import { filterDataFromSearch as de, filterData as ve, FilterPane as Te, Search as Se } from "@strata/react-filter-pane";
import { FormSectionWithRows as ye } from "@strata/react-form-section";
import { KpiLarge as G } from "@strata/react-kpi";
import { DragDropContext as Ne, Droppable as Ae, Draggable as De } from "react-beautiful-dnd";
const re = ({
  data: e = void 0,
  customTooltipContent: i = void 0
}) => /* @__PURE__ */ t(
  X,
  {
    className: "sds_data sds_data--primary",
    content: i || i === null ? i : e,
    hoverOpenDelay: 500,
    children: e ?? "--"
  }
), F = ({
  data: e = void 0,
  customTooltipContent: i = void 0
}) => /* @__PURE__ */ t(
  X,
  {
    className: "sds_data sds_data--secondary",
    content: i || i === null ? i : e,
    hoverOpenDelay: 500,
    children: e ?? "--"
  }
), nt = ({
  product: e = void 0,
  isBrand: i = !1,
  primary: n = !1
}) => /* @__PURE__ */ c("div", { className: "flex__gap--x-small", style: { alignItems: "center" }, children: [
  /* @__PURE__ */ t("span", { style: { flexGrow: 1, overflow: "hidden" }, children: n ? /* @__PURE__ */ t(re, { data: e }) : /* @__PURE__ */ t(F, { data: e }) }),
  i && /* @__PURE__ */ t(me, { label: "Brand" })
] }), lt = ({
  supplierName: e = void 0,
  lite: i = !1,
  primary: n = !1
}) => /* @__PURE__ */ c("div", { className: "flex__gap--x-small", style: { alignItems: "center" }, children: [
  /* @__PURE__ */ t("span", { style: { flexGrow: 1, overflow: "hidden" }, children: n ? /* @__PURE__ */ t(re, { data: e }) : /* @__PURE__ */ t(F, { data: e }) }),
  /* @__PURE__ */ t(ge, { lite: i })
] }), xe = () => {
  const { height: e, width: i, ref: n } = he(), d = (e ?? 0) > 220 && (i ?? 0) > 220;
  return /* @__PURE__ */ t("div", { ref: n, className: "sds_no-results", children: /* @__PURE__ */ t(
    q,
    {
      className: "margin__around--medium",
      size: d ? q.Sizes.MEDIUM : q.Sizes.SMALL,
      icon: U.SEARCH,
      primaryText: "No results to show.",
      secondaryText: "Try a different search."
    }
  ) });
}, h = {
  PAST_DAY: "PAST_DAY",
  PAST_WEEK: "PAST_WEEK",
  PAST_MONTH: "PAST_MONTH",
  PAST_QUARTER: "PAST_QUARTER",
  PAST_YEAR: "PAST_YEAR"
}, Re = {
  [h.PAST_DAY]: "Past Day",
  [h.PAST_WEEK]: "Past Week",
  [h.PAST_MONTH]: "Past Month",
  [h.PAST_QUARTER]: "Past Quarter",
  [h.PAST_YEAR]: "Past Year"
}, Ie = {
  [h.PAST_DAY]: (e) => S(e).isAfter(S().subtract(1, "day")),
  [h.PAST_WEEK]: (e) => S(e).isAfter(S().subtract(7, "day")),
  [h.PAST_MONTH]: (e) => S(e).isAfter(S().subtract(1, "month")),
  [h.PAST_QUARTER]: (e) => S(e).isAfter(S().subtract(90, "day")),
  [h.PAST_YEAR]: (e) => S(e).isAfter(S().subtract(1, "year"))
}, Ee = ({ getValue: e }) => /* @__PURE__ */ t(F, { data: e() }), ae = (e, i) => (e ?? Object.keys((i == null ? void 0 : i[0]) ?? {}).map((n) => ({
  header: n,
  accessorKey: n
}))).map((n) => ({
  size: 80,
  cell: Ee,
  ...n
})), k = ({
  data: e,
  isLoading: i,
  noResults: n,
  gridContent: d
}) => i ? /* @__PURE__ */ t("div", { className: "sds_grid__loading", children: /* @__PURE__ */ t(be, { inline: !0 }) }) : (e ?? []).length === 0 && n !== null ? n ?? /* @__PURE__ */ t(xe, {}) : d, Me = (e) => {
  const i = [
    .../* @__PURE__ */ new Set([
      ...Object.keys(h),
      ...Object.keys(e.optionOverrideMap ?? {})
    ])
  ];
  return {
    key: e.key,
    title: e.title ?? "Referral Time Frame",
    showCounts: e.showCounts ?? !1,
    useRadioButtons: !0,
    defaultValue: [e.defaultValue ?? h.PAST_YEAR],
    customValues: i.map((n) => {
      var d, l, r, g;
      return {
        value: n,
        text: ((l = (d = e.optionOverrideMap) == null ? void 0 : d[n]) == null ? void 0 : l.text) ?? Re[n],
        handler: ((g = (r = e.optionOverrideMap) == null ? void 0 : r[n]) == null ? void 0 : g.handler) ?? Ie[n]
      };
    })
  };
}, Oe = (e = 0, i = 0) => {
  const n = e * 50 + 1;
  return n > i ? i : n;
}, Pe = (e = 0, i = 0) => {
  const n = e * 50 + 50;
  return n > i ? i : n;
}, ze = ({
  currentPage: e = void 0,
  totalCount: i = void 0,
  onPageChange: n = void 0,
  showRecordCount: d = !0
}) => {
  const l = (e ?? 0) + 1, r = Math.ceil((i ?? 1) / 50), g = w(() => [...Array(r).keys()].map((o) => o + 1), [r]);
  return /* @__PURE__ */ c("div", { className: "sds_pagination", children: [
    /* @__PURE__ */ t("span", { className: "sds_pagination__text", children: "Page" }),
    /* @__PURE__ */ t(
      ue,
      {
        values: g,
        selectedItem: l,
        onChange: (o) => n == null ? void 0 : n(o - 1),
        small: !0,
        disabled: l === 1 && g.length === 1
      }
    ),
    /* @__PURE__ */ c("span", { className: "sds_pagination__text", children: [
      "Of ",
      r
    ] }),
    /* @__PURE__ */ t(
      Y,
      {
        icon: U.CHEVRON_LEFT,
        intent: Y.Intent.SECONDARY,
        size: 21,
        onClick: l === 1 ? void 0 : () => n == null ? void 0 : n(l - 2),
        title: "Previous Page",
        className: u({
          "sds_pagination__button--disabled": l === 1
        })
      }
    ),
    /* @__PURE__ */ t(
      Y,
      {
        icon: U.CHEVRON_RIGHT,
        intent: Y.Intent.SECONDARY,
        size: 21,
        onClick: l === r ? void 0 : () => n == null ? void 0 : n(l),
        title: "Next Page",
        className: u({
          "sds_pagination__button--disabled": l === r
        })
      }
    ),
    d && /* @__PURE__ */ c("span", { className: u("sds_pagination__text", "sds_pagination__text--count"), children: [
      "Showing ",
      Oe(e, i),
      "-",
      Pe(e, i),
      " of ",
      i ?? 0
    ] })
  ] });
}, se = ({ header: e }) => /* @__PURE__ */ t("th", { colSpan: e.colSpan, style: { width: e.getSize() }, children: /* @__PURE__ */ c(
  "div",
  {
    className: u("griddle-table-heading-cell", {
      "griddle-table-heading-cell--sortable": e.column.getCanSort()
    }),
    style: e.column.columnDef.headerStyle,
    role: "button",
    tabIndex: 0,
    onClick: e.column.getToggleSortingHandler(),
    onKeyDown: (i) => {
      var n;
      i.key === "Enter" && ((n = e.column.getToggleSortingHandler()) == null || n(i));
    },
    children: [
      Z(
        typeof e.column.columnDef.header == "string" ? /* @__PURE__ */ t(
          X,
          {
            className: "griddle-table-heading-cell__content",
            hoverOpenDelay: 500,
            content: e.column.columnDef.header,
            children: e.column.columnDef.header
          }
        ) : e.column.columnDef.header,
        e.getContext()
      ),
      {
        asc: /* @__PURE__ */ t("span", { children: "▲" }),
        desc: /* @__PURE__ */ t("span", { children: "▼" })
      }[e.column.getIsSorted().toString()]
    ]
  }
) }), He = [], oe = ({
  data: e = He,
  columns: i = void 0,
  isLoading: n = void 0,
  noResults: d = void 0,
  rowCssClass: l = void 0,
  enableSorting: r = !0,
  manualSorting: g = !1,
  sortProperties: o = void 0,
  onSort: s = void 0,
  onRowClick: m = void 0,
  currentPage: p,
  totalCount: _,
  onPageChange: b,
  showRecordCount: W = !0,
  topRightContent: A = void 0,
  thinRows: v = !1
}) => {
  const [M, x] = V(o ?? []);
  B(() => {
    o != null && x(o);
  }, [o]);
  const [O, K] = V({ top: [], bottom: [] }), y = ne({
    columns: ae(i, e),
    data: e,
    enableSorting: r,
    enableSortingRemoval: !1,
    enableRowPinning: !0,
    manualSorting: g,
    onSortingChange: (a) => {
      s == null || s(typeof a == "function" ? a(M) : a), x(a);
    },
    state: {
      sorting: M,
      rowPinning: O
    },
    getCoreRowModel: le(),
    getSortedRowModel: pe()
  }), P = _e(null), { rows: T } = y.getRowModel(), R = fe({
    getScrollElement: () => P.current,
    count: T.length,
    estimateSize: () => v ? 30 : 54,
    overscan: 5
  });
  B(() => {
    K({
      top: T.filter((a) => a.original.pinTop).map((a) => a.id),
      bottom: T.filter((a) => a.original.pinBottom).map((a) => a.id)
    });
  }, [T]);
  const D = J(
    ({ row: a }) => /* @__PURE__ */ t(
      "tr",
      {
        onClick: m ? () => m == null ? void 0 : m(a.original) : void 0,
        className: u(
          "griddle-row",
          { "griddle-row--clickable": m, "griddle-row--thin": v },
          l == null ? void 0 : l(a.original)
        ),
        children: a.getVisibleCells().map((I) => /* @__PURE__ */ t("td", { className: "griddle-cell", children: Z(I.column.columnDef.cell, I.getContext()) }, I.id))
      }
    ),
    [m, l, v]
  ), $ = J(() => {
    var z, H;
    const a = R.getVirtualItems(), I = R.getTotalSize(), L = ((z = a == null ? void 0 : a[0]) == null ? void 0 : z.start) ?? 0, Q = a.length > 0 ? I - (((H = a == null ? void 0 : a[a.length - 1]) == null ? void 0 : H.end) ?? 0) : 0;
    return k({
      data: e,
      isLoading: n,
      noResults: d,
      gridContent: /* @__PURE__ */ c("table", { className: "griddle-table", children: [
        /* @__PURE__ */ t(
          "thead",
          {
            className: u("griddle-table-heading", {
              "griddle-table-heading--thin": v
            }),
            children: y.getHeaderGroups().map((f) => /* @__PURE__ */ t("tr", { children: f.headers.map((N) => /* @__PURE__ */ t(se, { header: N }, N.id)) }, f.id))
          }
        ),
        /* @__PURE__ */ c("tbody", { className: "griddle-table-body", children: [
          L > 0 && /* @__PURE__ */ t("tr", { children: /* @__PURE__ */ t(
            "td",
            {
              style: { height: L },
              "aria-hidden": "true",
              tabIndex: -1
            }
          ) }),
          y.getTopRows().map((f) => /* @__PURE__ */ t(D, { row: f }, f.id)),
          a.filter((f) => T[f.index].getIsPinned() === !1).map((f) => {
            const N = T[f.index];
            return /* @__PURE__ */ t(D, { row: N }, N.id);
          }),
          y.getBottomRows().map((f) => /* @__PURE__ */ t(D, { row: f }, f.id)),
          Q > 0 && /* @__PURE__ */ t("tr", { children: /* @__PURE__ */ t(
            "td",
            {
              style: { height: Q },
              "aria-hidden": "true",
              tabIndex: -1
            }
          ) })
        ] })
      ] })
    });
  }, [R, n, e, d, v, T, y, D]);
  return /* @__PURE__ */ c(ce, { children: [
    (Number.isInteger(p) || A) && /* @__PURE__ */ c("div", { className: "sds_grid__top-container", children: [
      Number.isInteger(p) && /* @__PURE__ */ t(
        ze,
        {
          currentPage: p,
          totalCount: _,
          onPageChange: b,
          showRecordCount: W
        }
      ),
      A
    ] }),
    /* @__PURE__ */ t("div", { ref: P, className: "sds_grid__container", children: /* @__PURE__ */ t($, {}) })
  ] });
}, E = ({
  kpiData: e = void 0,
  gridData: i = void 0,
  className: n = void 0
}) => {
  const d = w(
    () => e == null ? void 0 : e.map((l) => {
      var r;
      return {
        ...l,
        value: (r = l.value) == null ? void 0 : r.call(l, i)
      };
    }),
    [e, i]
  );
  return /* @__PURE__ */ t(
    ye,
    {
      className: n,
      sectionTitle: "Totals",
      rowOneContent: d == null ? void 0 : d.map((l) => /* @__PURE__ */ t(
        G,
        {
          value: l.value,
          valueType: l.valueType,
          label: l.label,
          trendingIndicator: l.trendingIndicator
        },
        l.label
      ))
    }
  );
};
E.ValueTypes = G.ValueTypes;
E.TrendStates = G.TrendStates;
E.TrendDirections = G.TrendDirections;
const C = ({
  data: e,
  columns: i,
  isLoading: n,
  rowCssClass: d,
  onRowClick: l,
  title: r,
  secondaryTitle: g,
  headerContent: o,
  viewsPaneContent: s,
  filterCategories: m,
  activeFilters: p,
  onFilter: _,
  filterPaneRenderWidth: b = void 0,
  onFilterPaneResize: W = void 0,
  enableSorting: A = !0,
  manualSorting: v = !1,
  sortProperties: M,
  onSort: x,
  enableSearch: O = !1,
  customSearchValueHandlers: K = void 0,
  searchText: y,
  onSearch: P,
  kpiData: T,
  timeFrameConfig: R = void 0,
  currentPage: D,
  totalCount: $,
  onPageChange: a,
  showRecordCount: I = !0,
  topRightContent: L = void 0,
  thinRows: Q = !1
}) => {
  const z = w(
    () => R ? [Me(R), ...m ?? []] : m,
    [m, R]
  ), [H, f] = V(p);
  B(() => {
    p != null && f(p);
  }, [p]);
  const [N, ee] = V(
    O ? y : void 0
  );
  B(() => {
    ee(O ? y : void 0);
  }, [y, O]);
  const te = w(
    () => (
      // If currentPage is set, filtering & search controlled by backend
      Number.isInteger(D) ? e : de(
        ve(e, H, z),
        N,
        K
      )
    ),
    [
      e,
      H,
      z,
      N,
      K,
      D
    ]
  );
  return /* @__PURE__ */ t(
    Te,
    {
      paneRenderWidth: b,
      onPaneResize: W,
      title: r,
      secondaryTitle: g,
      headerContent: o,
      viewsPaneContent: s,
      filterCategories: z,
      activeFilters: H,
      onFilter: (j) => {
        _ == null || _(j), f(j);
      },
      enableSearch: O,
      searchText: N,
      onSearch: (j) => {
        P == null || P(j), ee(j);
      },
      data: e,
      mainContent: /* @__PURE__ */ c(
        "div",
        {
          style: {
            height: "100%",
            width: "100%",
            display: "flex",
            flexDirection: "column"
          },
          children: [
            T && /* @__PURE__ */ t(
              E,
              {
                className: "margin__bottom--medium",
                kpiData: T,
                gridData: te
              }
            ),
            /* @__PURE__ */ t(
              oe,
              {
                data: te,
                columns: i,
                isLoading: n,
                rowCssClass: d,
                enableSorting: A,
                manualSorting: v,
                sortProperties: M,
                onSort: x,
                onRowClick: l,
                currentPage: D,
                totalCount: $,
                onPageChange: a,
                showRecordCount: I,
                topRightContent: L,
                thinRows: Q
              }
            )
          ]
        }
      )
    }
  );
};
C.ValueTypes = E.ValueTypes;
C.TrendStates = E.TrendStates;
C.TrendDirections = E.TrendDirections;
const Ye = (e, i, n) => {
  const d = [...e], [l] = d.splice(i, 1);
  return d.splice(n, 0, l), d;
}, we = (e, i) => {
  if (!i || !e.destination || e.source.index === e.destination.index && e.source.droppableId === e.destination.droppableId)
    return i;
  if (e.source.droppableId === e.destination.droppableId)
    return i.map(
      (d, l) => l.toString() === e.source.droppableId ? {
        ...d,
        data: Ye(d.data, e.source.index, e.destination.index)
      } : d
    );
  const [n] = [...i[Number(e.source.droppableId)].data].splice(
    e.source.index,
    1
  );
  return i.map((d, l) => {
    if (l.toString() === e.source.droppableId) {
      const r = [...d.data];
      return r.splice(e.source.index, 1), { ...d, data: r };
    }
    if (l.toString() === e.destination.droppableId) {
      const r = [...d.data];
      return r.splice(e.destination.index, 0, n), { ...d, data: r };
    }
    return d;
  });
}, ie = (e, i) => e.droppable !== !1 && i.original.draggable !== !1, Ve = ({
  group: e,
  groupIndex: i,
  columns: n,
  rowCssClass: d = void 0
}) => {
  const l = w(() => e.data ?? [], [e.data]), r = ne({
    columns: ae(n, l),
    data: l,
    enableSorting: !1,
    getCoreRowModel: le()
  }), g = J(
    () => k({
      data: l,
      isLoading: !1,
      noResults: null,
      gridContent: /* @__PURE__ */ c("table", { className: "griddle-table", children: [
        i === 0 ? /* @__PURE__ */ t("thead", { className: "griddle-table-heading", children: r.getHeaderGroups().map((o) => /* @__PURE__ */ c("tr", { children: [
          /* @__PURE__ */ t(
            "th",
            {
              colSpan: 1,
              style: { width: 12 },
              "aria-label": "Drag Handle"
            }
          ),
          o.headers.map((s) => /* @__PURE__ */ t(se, { header: s }, s.id))
        ] }, o.id)) }) : /* @__PURE__ */ t(
          "thead",
          {
            className: u("griddle-table-heading", {
              "griddle-table-heading--hidden": !e.header
            }),
            children: /* @__PURE__ */ c("tr", { children: [
              /* @__PURE__ */ t("th", { colSpan: 1, style: { width: 12 }, children: /* @__PURE__ */ t(
                "div",
                {
                  className: u(
                    "griddle-table-heading-cell",
                    "griddle-table-heading-cell__content",
                    "griddle-table-heading-cell__content--droppable-group"
                  ),
                  children: e.header
                }
              ) }),
              r.getHeaderGroups().map(
                (o) => o.headers.map((s) => /* @__PURE__ */ t(
                  "th",
                  {
                    style: { width: s.getSize() },
                    "aria-hidden": "true",
                    tabIndex: -1,
                    children: /* @__PURE__ */ t("div", { className: "griddle-table-heading-cell" })
                  },
                  s.id
                ))
              )
            ] })
          }
        ),
        /* @__PURE__ */ t(
          Ae,
          {
            droppableId: i.toString(),
            isDropDisabled: e.droppable === !1,
            children: (o) => /* @__PURE__ */ c(
              "tbody",
              {
                ...o.droppableProps,
                ref: o.innerRef,
                className: u("griddle-table-body", {
                  "griddle-table-body--droppable-empty": l.length === 0,
                  "griddle-table-body--droppable-disabled": e.droppable === !1
                }),
                children: [
                  r.getRowModel().rows.map((s, m) => /* @__PURE__ */ t(
                    De,
                    {
                      draggableId: `${i}${s.id}`,
                      isDragDisabled: !ie(e, s),
                      index: m,
                      children: (p, _) => /* @__PURE__ */ c(
                        "tr",
                        {
                          ...p.draggableProps,
                          ref: p.innerRef,
                          className: u(
                            "griddle-row",
                            "griddle-row--draggable",
                            {
                              "griddle-row--dragging": _.isDragging
                            },
                            d == null ? void 0 : d(s.original)
                          ),
                          children: [
                            /* @__PURE__ */ t(
                              "td",
                              {
                                ...p.dragHandleProps,
                                style: { width: 18 },
                                children: ie(e, s) && /* @__PURE__ */ t(
                                  Y,
                                  {
                                    className: "padding__around--small",
                                    title: "Drag",
                                    icon: U.DRAG_HANDLE_VERTICAL,
                                    intent: Y.Intent.SECONDARY
                                  }
                                )
                              }
                            ),
                            s.getVisibleCells().map((b) => /* @__PURE__ */ t(
                              "td",
                              {
                                className: "griddle-cell",
                                style: _.isDragging ? {
                                  flexBasis: b.column.getSize()
                                } : void 0,
                                children: Z(
                                  b.column.columnDef.cell,
                                  b.getContext()
                                )
                              },
                              b.id
                            ))
                          ]
                        }
                      )
                    },
                    s.id
                  )),
                  o.placeholder
                ]
              }
            )
          }
        )
      ] })
    }),
    [l, e, i, r, d]
  );
  return /* @__PURE__ */ t("div", { className: "sds_grid__container sds_grid__container--draggable", children: /* @__PURE__ */ t(g, {}) });
}, dt = ({
  dataGroups: e = void 0,
  columns: i,
  onReorder: n,
  isLoading: d = !1,
  noResults: l = void 0,
  rowCssClass: r
}) => {
  const [g, o] = V(!1);
  return d || (e ?? []).map(({ data: s }) => s).flat().length === 0 ? /* @__PURE__ */ t("div", { className: "sds_grid__container sds_grid__container--draggable", children: k({
    data: [],
    isLoading: d,
    noResults: l,
    gridContent: null
  }) }) : /* @__PURE__ */ t(
    "div",
    {
      className: u("sds_grid__group-container", {
        "sds_grid__group-container--dragging": g
      }),
      children: /* @__PURE__ */ t(
        Ne,
        {
          onDragStart: () => o(!0),
          onDragEnd: (s) => {
            o(!1), n(we(s, e));
          },
          children: e == null ? void 0 : e.map((s, m) => /* @__PURE__ */ t(
            Ve,
            {
              group: s,
              groupIndex: m,
              columns: i,
              rowCssClass: r
            },
            m
          ))
        }
      )
    }
  );
}, rt = ({
  data: e,
  columns: i,
  rightHeaderContent: n = void 0,
  isLoading: d,
  rowCssClass: l,
  onRowClick: r,
  enableSorting: g = !0,
  manualSorting: o = !1,
  sortProperties: s,
  onSort: m,
  customSearchValueHandlers: p = void 0,
  searchText: _ = void 0,
  onSearch: b = void 0,
  thinRows: W = !1
}) => {
  const [A, v] = V(_);
  B(() => {
    v(_);
  }, [_]);
  const M = w(
    () => de(e, A, p),
    [e, A, p]
  );
  return /* @__PURE__ */ c(
    "div",
    {
      style: {
        height: "100%",
        width: "100%",
        display: "flex",
        flexDirection: "column"
      },
      children: [
        /* @__PURE__ */ c(
          "div",
          {
            className: "margin__bottom--medium",
            style: { display: "flex", alignItems: "center", justifyContent: "space-between" },
            children: [
              /* @__PURE__ */ t(
                Se,
                {
                  className: "margin__right--small",
                  value: A,
                  onSearch: (x) => {
                    b == null || b(x), v(x);
                  }
                }
              ),
              n
            ]
          }
        ),
        /* @__PURE__ */ t(
          oe,
          {
            data: M,
            columns: i,
            isLoading: d,
            rowCssClass: l,
            enableSorting: g,
            manualSorting: o,
            sortProperties: s,
            onSort: m,
            onRowClick: r,
            thinRows: W
          }
        )
      ]
    }
  );
};
export {
  oe as Grid,
  C as GridWithFilters,
  dt as GridWithReordering,
  rt as GridWithSearch,
  E as KpiSection,
  re as PrimaryData,
  nt as ProductCell,
  F as SecondaryData,
  lt as SupplierCell,
  Re as TimeFrameDisplayText,
  h as TimeFrameOptions
};
//# sourceMappingURL=index.js.map
